@if (templateList(); as templates) {
  <div [class]="hideHeaders ? 'flex flex-col gap-4' : 'grid grid-cols-2 gap-4'">
    @for (pair of templates; track index; let index = $index) {
      <div>
        @if (!hideHeaders) {
          <h2>
            {{ pair.template | map: getTemplateName | splitCamel | titlecase }}
          </h2>
        }
        <mat-form-field class="w-full">
          <mat-label>
            Select
            {{ pair.template | map: getTemplateName | splitCamel | titlecase }}
          </mat-label>
          <mat-select
            #selectRef
            [compareWith]="compareFn"
            (selectionChange)="templateChanges()"
          >
            <mat-option [value]="undefined">None</mat-option>
            @if (pair.templateDoc.content | map: templateHasContent) {
              <mat-option
                [value]="{
                  template: pair.template,
                  content: pair.templateDoc.content
                }"
              >
                {{
                  pair.template | map: getTemplateName | splitCamel | titlecase
                }}
              </mat-option>
            }
            @if (pair.templateDoc.variants?.length) {
              @for (
                variant of pair.templateDoc.variants;
                track variant.uid;
                let index = $index
              ) {
                @if (variant.content | map: templateHasContent) {
                  <mat-option
                    [value]="{
                      template: pair.template,
                      content: variant.content
                    }"
                  >
                    {{ variant | pairMap: index : getVariantName : this }}
                  </mat-option>
                }
              }
            }
          </mat-select>
          @if (useTooltipHints) {
            @if (pair.template | map: getTemplateHint; as templateHint) {
              <mat-icon
                matSuffix
                class="icon-sm cursor-pointer text-slate-400"
                [matTooltip]="'This is displayed ' + templateHint"
              >
                help_outline
              </mat-icon>
            }
          }
        </mat-form-field>
        @if (!useTooltipHints) {
          @if (pair.template | map: getTemplateHint; as templateHint) {
            <p class="text-xs text-slate-400">
              This is displayed {{ templateHint }}
            </p>
          }
        }
      </div>
    }
  </div>
}
